import React from 'react';

import { EmptyView } from '@neptune/shared/common-ui';

export const ServiceAccountsPlaceholder = () => {
  return (
    <EmptyView
      variant="default"
      title="Service accounts are not available"
      subtitle="Contact your workspace administrator"
      icon="service-account"
      data-role="team-empty-state"
    />
  );
};
